import React, { HTMLAttributes, ReactHTML, useRef } from "react";
import "./Droppable.scss";
import { DraggedElement } from "../Draggable/Draggable";

// @ts-ignore
interface IProps extends HTMLAttributes<HTMLElement> {
    element?: keyof ReactHTML
    shouldAppend?: boolean
    onDrop?: ((elm: HTMLElement) => void) | ((elm: HTMLElement, event: PointerEvent) => void)
    maxCount?: number
}

export function Droppable(props: IProps) {
    const ref = useRef<HTMLElement>(null);
    const {
        element = 'div',
        className = '',
        children,
        onDrop,
        shouldAppend,
        maxCount = 1,
        ...otherProps
    } = props;

    const handleDragEnd = (e: PointerEvent) => {
        if (DraggedElement) {
            if (ref.current) {
                if (shouldAppend) {
                    const children = ref.current.children;
                    if (children.length === maxCount) return;
                    ref.current.appendChild(DraggedElement);
                }
                if (onDrop) {
                    onDrop(DraggedElement, e);
                }
            }
        }
    }

    return React.createElement(element, {
        ref,
        className: `is-droppable ${className}`,
        onPointerUp: handleDragEnd,
        ...otherProps,
    }, children);
}
